import React from 'react';
import {
    Dialog,
    CircularProgress,
    Grid
} from '@mui/material';
import { connect } from 'react-redux';

interface Props {
    loading: boolean,
    size: number,
    thickness: number,
    description: string,
    extra?: string;
    settings: any,
}

const ProgressSpinner: React.FC<Props> = props => {
    const { size, thickness, description, extra, loading, settings } = props;

    const textStyle = settings?.Styles?.OverrideLoadingSpinnerTextColor ? { color: settings.Styles.OverrideLoadingSpinnerTextColor } : undefined;

    return (
        <Dialog open={loading} fullScreen hideBackdrop PaperProps={{ style: { background: 'transparent', boxShadow: 'none' } }}>
            <div className='d-flex flex-direction-column align-items-center justify-content-center' style={{ position: 'relative', height: '100%', width: '100%' }} >
                {/* See-through light veil (as on the client portal) instead of the dark screen. */}
                <div style={{ position: 'absolute', inset: 0, opacity: 0.8, background: settings?.Styles?.OverrideLoadingSpinnerBackgroundColor ? settings?.Styles?.OverrideLoadingSpinnerBackgroundColor : "rgba(243, 245, 247, 0.9)" }} />
                {/* Spinner and message in the middle of the screen. */}
                <div className="pb-loader-card">
                    <CircularProgress size={Math.min(size || 40, 44)} thickness={thickness} style={{ color: settings?.Styles?.OverrideLoadingSpinnerColor ? settings?.Styles?.OverrideLoadingSpinnerColor : settings?.Styles?.Primary }} />
                    {description && <div className="pb-loader-text" style={textStyle}>{description}</div>}
                    {description && extra && <div className="pb-loader-text pb-loader-extra" style={textStyle}>{extra}</div>}
                </div>
            </div>
        </Dialog>
    )
}

const mapStateToProps = (state: any) => ({
    settings: state.settings.settings,
    loading: state.progressSpinner.loading,
    size: state.progressSpinner.size,
    thickness: state.progressSpinner.thickness,
    description: state.progressSpinner.description,
    extra: state.progressSpinner.extra
})

export default connect(mapStateToProps)(ProgressSpinner);
